export const currencySymbol = 'Tk';
export const currencySymbolF = 'Tk ';
export const mesuringUnit = 'cm';
export const mesuringUnitPlural = 'centimeters';
export const weightUnit = 'gm';
export const weightUnitPlural = 'grams';
export const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const month = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];

export const countryList = ['Canada'];

export const provinceList = [
	'Alberta',
	'British Columbia',
	'Manitoba',
	'New Brunswick',
	'Newfoundland and Labrador',
	'Northwest Territories',
	'Nova Scotia',
	'Nunavut',
	'Ontario',
	'Prince Edward Island',
	'Quebec',
	'Saskatchewan',
	'Yukon',
];

export const fallbackErrorMessage = 'Please contact support';

export const imageDimensions = {
	mainPick: {
		height: 1024,
		width: 1024,
	},
	lg: {
		height: 900,
		width: 900,
	},
	sm: {
		height: 480,
		width: 480,
	},
	lgThumb: {
		height: 320,
		width: 320,
	},
	smThumb: {
		height: 180,
		width: 180,
	},
};

export const stockSellOpts: { [key: string]: string } = {
	stockBased: 'Respect stock',
	stockIgnored: 'Ignore stock',
	preOrderOnly: 'Pre-Order only',
};
